import { render, staticRenderFns } from "./DataListLibraries.vue?vue&type=template&id=8dc47204&scoped=true&"
import script from "./DataListLibraries.vue?vue&type=script&lang=js&"
export * from "./DataListLibraries.vue?vue&type=script&lang=js&"
import style0 from "./DataListLibraries.vue?vue&type=style&index=0&id=8dc47204&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc47204",
  null
  
)

export default component.exports